import React, { Component } from 'react';

class ButtonHoverRender extends Component {
  constructor() {
    super();
    this.state = {
      hovering: false,
    };
  }

  onMouseEnter = () => {
    this.setState({ hovering: true });
  };

  onMouseLeave = () => {
    this.setState({ hovering: false });
  };

  render() {
    return (
      <React.Fragment>
        {this.props.render({
          onEnter: this.onMouseEnter,
          onLeave: this.onMouseLeave,
          hovering: this.state.hovering,
        })}
      </React.Fragment>
    );
  }
}

export default ButtonHoverRender;
